export default __webpack_public_path__ + "locales/sr-Latn-RS/DeleteDialog.json?hash=64be90ac6fdd925d9ce1d79943d7a709";